import React, { useState } from 'react';

const AddCompletionNoteModal = ({ isOpen, onClose, onSave }) => {
    const [noteText, setNoteText] = useState('');

    if (!isOpen) return null;

    const handleSave = () => {
        onSave(noteText);
        setNoteText(''); // Reset for next time
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[70]">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
                <h2 className="text-lg font-semibold mb-4">Add Completion Note</h2>
                <p className="text-sm text-gray-600 mb-4">
                    Please add a brief note about the outcome of this appointment or follow-up. This will be saved to the customer's contact history.
                </p>
                <textarea
                    value={noteText}
                    onChange={(e) => setNoteText(e.target.value)}
                    rows="4"
                    className="w-full p-2 border rounded-md"
                    placeholder="e.g., Discussed project timeline, customer is happy..."
                />
                <div className="flex justify-end space-x-3 mt-4">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">
                        Skip
                    </button>
                    <button type="button" onClick={handleSave} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
                        Save Note & Complete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddCompletionNoteModal;